import React, { FC, useCallback } from "react";
import { MiniChat } from "@zeemee/react-web-chat";
import { useProtectedNavigation } from "@/routes/useProtectedNavigation";
import { useLocation } from "react-router-dom";

export const ReactWebChatMiniChat: FC = () => {
  const location = useLocation();
  const { navToRoute } = useProtectedNavigation();

  const handleChatClick = useCallback(
    (chat: string | null) => chat && navToRoute("selectedChat", { chat }),
    [navToRoute],
  );

  if (location.pathname.includes("/chat")) {
    return null;
  }

  return <MiniChat onChatClick={handleChatClick} />;
};
